<template>
	<div class="totop">
		<div class="topItem" @click="totop">
			<img src="@/images/totop.png"/>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'totop',
		data() {
			return {
				isMoving: false,
				backPosition: 0,
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			totop() {
				if(this.isMoving) {
					return
				}
				const start = window.pageYOffset;
				let i = 0
				this.isMoving = true
				this.interval = setInterval(() => {
					const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500))
					if(next <= this.backPosition) {
						window.scrollTo(0, this.backPosition)
						clearInterval(this.interval)
						this.isMoving = false
					} else {
						window.scrollTo(0, next)
					}
					i++
				}, 16.7)
			},
			easeInOutQuad(t, b, c, d) {
				if((t /= d / 2) < 1) return c / 2 * t * t + b
				return -c / 2 * (--t * (t - 2) - 1) + b
			}
		},
	}
</script>